import script from "./AllMinerals.vue?vue&type=script&setup=true&lang=js"
export * from "./AllMinerals.vue?vue&type=script&setup=true&lang=js"

import "./AllMinerals.vue?vue&type=style&index=0&id=3e599ea8&lang=css&scoped=true"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e599ea8"]])

export default __exports__